// extracted by mini-css-extract-plugin
module.exports = {"root":"WebshopRelatedArticles_root__3ePDT","spinnerHolder":"WebshopRelatedArticles_spinnerHolder__2S1hu","spinner":"WebshopRelatedArticles_spinner__kM-7C"};